module.exports = "/_next/static/media/feed-blur.65c522d4.png";